<template>
  <div>
    <!-- Location -->
    <div v-if="locationcurrent"> 
        <div class="osm-mapcontainer"
          :class="{ expanded: expand }" 
          :style=" (expand && window.height < 660) ?  'height: '+ window.height + 'px;width: ' + window.height + 'px; margin-left: ' + (window.height/2)*-1 + 'px; margin-bottom: ' + ((window.height/2)+30)*-1 + 'px' : 'border: none;' "
          >             
            <div class="inner">

              <!--
              <div v-if="tourdata">
                <div
                  v-for="(td, t) in tourdata"
                  :key="t"
                  >
                  {{ td.id }} {{ td.pano_id }} {{ td.loc_x }} {{ td.loc_y  }} {{ td.loc_id }}<br>
                  <b>{{ td.latitude }}|{{ td.longitude }}</b>
                </div>
              </div>
              -->

              <Logo v-if="$template !== 'icampus'" class="logocomp" :locationkey="locationcurrent.loc_key"></Logo>
          
              <iframe
                ref="mapIframe"
                src="https://maps.th-wildau.de?controls=0&lat=52.318700&lng=13.631239&zoom=15"
                width="100%"
                height="300"
                @load="onIframeLoad"
              ></iframe>

            </div>
        </div>

    </div>
  </div>
</template>

<script>

//import { useWindowSize } from 'vue-window-size';
import Logo from '../../components/elements/Logo';

export default {
  name: 'PanoMap',
  props: ['locationdata', 'panocurrent', 'currentitem', 'position', 'map', 'tourdata'],  
  components: {
    Logo
  },  
  data () {
    return {    
      locationcurrent: null,
      expand: false,
      radarheight: 0,      
      //windowWidth: null,
      //windowheight:0,      
      navLevel: null,
      activeLevelId: null,
      window: {
            width: 0,
            height: 0
        }
    }
  },
  methods: {
    getCurrentLocation () {
        var value = this.panocurrent;
        this.locationcurrent = this.locationdata.find(loc => loc.id == value.loc_id);                        
        this.activeLevelId = this.locationcurrent.id;          
    },
    switchLevel (level) {
      this.activeLevelId = level.id;
      if(level.id == this.panocurrent.loc_id) {
        this.navLevel = null 
      } else {
        this.navLevel = level
      }      
    },
    windowSize () {      
      //console.log("set radar size");      
      //console.log(this.radarheight);               
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    onIframeLoad() {
      setTimeout( () => {
        this.sendMarker();
      }, 200);
    },
    sendMarker() {

      console.log('Start sendMarker');

      // const iframe = document.getElementById('map');
      const iframe = this.$refs.mapIframe;
      // console.log(iframe);

      const IFRAME_ORIGIN = new URL(iframe.src).origin;

      // console.log("Iframe origin", IFRAME_ORIGIN);
      // console.log('current', this.panocurrent.id);

      window.addEventListener('message', (e) => {
        console.log('Message from iframe:', e.origin, e.data);
        console.log('Click on POI (ID):', e.data.id);
      });

      setTimeout( () => {

        iframe.contentWindow.postMessage(
          { type: 'maps:init' }, IFRAME_ORIGIN
        );
        console.log('maps:init sent after 400 ms');

      }, 400);

      setTimeout( () => {

        const panid = this.panocurrent.id;

        const markers = this.tourdata.map(item => ({
          unique_id: item.id,
          node: {
            icon: 'circle_sdf',
            icon_size: panid === item.pano_id ? 0.7 : 0.4,
            lat: item.latitude,
            lng: item.longitude
          }
        }));

        iframe.contentWindow.postMessage(
          {
            type: 'maps:create-markers',
            markers: markers
            /*
            markers: [
              {
                unique_id: 1,
                node: {
                    icon: 'circle_sdf',
                    icon_size: 0.5,
                    lat: 52.319336,
                    lng: 13.632341
                }
              },
              {
                unique_id: 2,
                node: {
                    icon: 'circle_sdf',
                    icon_size: 0.5,
                    lat: 52.319536,
                    lng: 13.632541
                }
              }              
            ],
            */
          },
          IFRAME_ORIGIN
        );

        console.log('Markers sent after 400 ms');

      }, 400);

      // iframe.contentWindow.postMessage(
      //   { type: 'maps:init' },
      //   origin
      // );

      // // Marker senden
      // setTimeout(()=> {

      //   iframe.contentWindow.postMessage(
      //   {
      //     type: 'maps:create-markers',
      //     markers: [
      //       {
      //         unique_id: 1234,
      //         node: {
      //           icon: 'circle_sdf',
      //           // icon: 'https://icampus.th-wildau.de/vr/img/spot/red-dot.png',
      //           icon_size: 0.5,
      //           lat: 52.319349,
      //           lng: 13.632228
      //         }
      //       }
      //     ]
      //   },
      //   origin
      // );

      // }, 1000)

    }
  },
  watch: {
    panocurrent: {            
      //immediate: true,
      handler (e) {
        this.panocurrent = e;
        /**
         * Get current location
         */
        this.getCurrentLocation();
        /**
         * Update OSM
         */
        this.sendMarker();
      }
    },
    locationdata: {
      handler () {
          // console.log("watch locationdata")
      }    
    }
  },
  created () {        
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  mounted () {
    if(this.map == 1) this.expand = true;    
    this.getCurrentLocation();
  }  
}
</script>

<style>
.tourmap {
  overflow:hidden;
}
.logocomp {
  position: absolute;
  top:0;
  left:0;
  z-index:9;
  padding:6px 10px;
  background-color: rgba(255,255,255,0.6);
}
.expanded .logocomp {
  padding:10px;
  background-color: rgba(255,255,255,0.6);
}
.mapcontainer {
  width:120px;
  height:120px;
  position: relative;
}
.mapcontainer iframe,
.osm-mapcontainer iframe {
  height:210px !important;
  border: 0;
}

.mapcontainer.expanded {  
  left:50%;
  bottom:50%;  
  width:680px;
  height:680px;
  margin-bottom:-370px;
  margin-left:-340px;
  display: table;
  padding:40px;  
}
.mapcontainer.expanded .inner {  
  display: table-cell;
  vertical-align: bottom;
  position:relative;
    box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.25);
  -webkit-box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.25);
  -moz-box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.25);
}
.mapcontainer .loc {
  width:100%;
  max-height:100%;
  opacity:0.7;
}
.mapcontainer.expanded .loc {
  opacity:0.92;
}
.mapcontainer .redspot {
  position:absolute;
  width:18px;
  z-index:10;
  margin-left:-9px;
  margin-top:-9px;
  padding:4px;
  line-height:0;
}
.mapcontainer .redspot:hover {
  cursor:pointer;
}
.mapcontainer .redspot img {
  width:100%;
  height:auto;
}
.mapcontainer .locname {
  position:absolute;
  left:0;
  bottom:0;
  font-size:0.82rem;
  padding:4px 10px;
}
.mapcontainer .levels {
  position:absolute;
  right:4px;
  bottom:38px;
  font-size:0.82rem;
  padding:0;  
  width:30px;
  z-index:99;
  text-align:center;  
}
.mapcontainer .level {
  display:block;
  background-color:#ffffff;
  padding:4px 6px;
  margin:0;
  cursor: pointer;
}
.mapcontainer .level.active {
  background-color:#dddddd;
  cursor: default;
  font-weight:600;
}
.radar {
  position:absolute;
  z-index:9;
  width:100%;
  height:100%;
  top:0;
  left:0;
  pointer-events: none;
}
.mapcontainer.expanded .radar {  
  display:none;
}
.mapcontainer.expanded .levels {
  bottom:6px;
}
.radar > div {
  position:absolute;
  margin-left:-50%;
  margin-top:-50%;
  width:100%;
  height:100%;
}
.expand {
  position: absolute;
  bottom:4px;
  right:4px;
  width:30px;
  height:36px;
  min-width:30px !important;
  padding:0 !important;
  z-index:99;
}
.collaps {
  position: absolute;
  top:0px;
  right:-44px;
  width:40px;
  height:40px;
  min-width:40px !important;
  padding:0 !important;
  z-index:99;
}

@media only screen and (min-width: 760px) {
    .mapcontainer {
      width:440px;
      height:440px;
      margin: 0 auto;
    }
}

</style>
